<template>
  <div>
    <jczh-table-content
      ref="table"
      :data="pageTableList"
      :option="tableOption"
      :table-id="tableId"
      :selected="echoList"
      :selection="selection && !disabled"
      @selection-change="changeSelection"
    >
      <!--表头插槽-->
      <template
        v-for="item in headerSlotList"
        v-slot:[item.headerSlot]="{ option }"
      >
        <slot
          :name="item.headerSlot"
          :option="option"
          :$index="rowIndex"
        ></slot>
      </template>

      <!--表格内容插槽-->
      <template
        v-for="item in slotList"
        v-slot:[item.slotName]="{ row, rowIndex }"
      >
        <slot :name="item.slotName" :row="row" :$index="rowIndex"></slot>
      </template>
    </jczh-table-content>

    <pagination
      v-show="pagination && tableList.length > size"
      :total="tableList.length"
      :page-sizes="pageSizes"
      size="small"
      :page.sync="page"
      :limit.sync="size"
    />
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'

// 工具函数
import { strToThousands } from '@/utils/utils.js'

export default {
  name: 'MaterialItemTable',

  components: { Pagination },

  props: {
    tableList: {
      type: Array,
      default: () => []
    },

    /**
     * 表格表头定义函数
     * 若字段prop的与内部定义不同，使用transProp进行定义
     * 若要增加其他字段，只需要{prop: 对应字段，增加的字段}
     */
    tableConfigFun: {
      type: Function,
      default: tableConfig => tableConfig
    },

    /**
     * 已选的回显表格数据
     */
    echoList: {
      type: Array,
      default: () => []
    },

    /**
     * 是否使用前端模拟分页
     */
    pagination: {
      type: Boolean,
      default: false
    },

    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50]
      }
    },

    selection: {
      type: Boolean,
      default: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    showOperation: {
      type: Boolean,
      default: true
    },

    tableId: {
      type: String,
      default: 'spuCode'
    }
  },

  data() {
    return {
      pageTableList: [],
      page: 1,
      size: 20,

      // 组件默认的tableConfig
      tableConfig: [
        { label: '品目编码', prop: 'itemCode', minWidth: 100 },
        { label: '品目名称', prop: 'itemName', minWidth: 100 },
        { label: '参数型号', prop: 'itemModel', minWidth: 100 },
        { label: '品牌/制造商', prop: 'itemBrand', minWidth: 100 },
        { label: '品目单位', prop: 'unitType' },
        { label: '数量', prop: 'itemNum' },
        {
          label: '预算单价(元)',
          prop: 'unitPrice',
          filter: value => strToThousands(value) || '-',
          minWidth: 120
        },
        {
          label: '预算总价(元)',
          prop: 'totalPrice',
          filter: value => strToThousands(value) || '-',
          minWidth: 120
        },
        { label: '税率(%)', prop: 'taxRate' },
        { label: '交货地点', prop: 'deliveryAddress', minWidth: 100 },
        { label: '交货时间(天)', prop: 'deliveryDay', minWidth: 120 },
        { label: '备注', prop: 'remarks', minWidth: 100 }
        // { label: '附件', slotName: 'attachment', minWidth: 160 }
      ]
    }
  },

  computed: {
    totalPage() {
      return Math.ceil(this.tableList.length / this.size)
    },

    tableOption() {
      const temp = this.tableConfigFun(this.tableConfig).map(value => {
        const findObj = this.tableConfig.find(
          config => config.prop === value.prop
        )

        if (!findObj) return value

        return Object.assign({}, findObj, value, {
          prop: value.transProp || value.prop
        })
      })

      return this.showOperation
        ? [...temp, { label: '操作', slotName: 'operation', width: 160, fixed: 'right' }] : temp
    },

    /**
     * 需要被插槽的表格配置项
     */
    slotList() {
      return this.tableOption.filter(value => value.slotName)
    },

    headerSlotList() {
      return this.tableOption.filter(value => value.headerSlot)
    }
  },

  watch: {
    tableList: {
      handler: function(newVal) {
        if (this.pagination) {
          this.page = 1
          this.getPageData()
        } else {
          this.pageTableList = newVal
        }
      },
      immediate: true
    },

    page() {
      this.getPageData()
    },
    size() {
      this.getPageData()
    }
  },

  methods: {
    /**
     * @description: 前端分页，获取当前页数据
     */
    getPageData() {
      const start = (this.page - 1) * this.size
      const end = start + this.size
      this.pageTableList = this.tableList.slice(start, end)
    },

    /**
     * 表格多选回调函数
     * @param selection
     */
    changeSelection(selection) {
      this.$emit('selectionChange', selection)
    },

    /**
     * 清空选中项
     */
    clearSelection() {
      this.$refs.table.clearSelection()
    }
  }
}
</script>
